import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PopupAction } from "../../enums/popup-action.enum";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-popup",
  templateUrl: "./popup.component.html",
  styleUrls: ["./popup.component.sass"],
})

export class PopupComponent implements OnInit {

  @Input() actionType: string;
  @Input() isLoading: boolean;
  @Output() confirmDeletion = new EventEmitter<Boolean>();
  @Output() confirmCancellation = new EventEmitter<Boolean>();
  @Output() confirmPeeringCreation = new EventEmitter<Boolean>();

  selectedOption: string;
  popupTitle: string;
  popupMessage: string;
  showRadioButton: boolean;
  showCancelButton: boolean;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.selectedOption = "no";
    this.showCancelButton = true;
    this.configurePopup();
  }

  configurePopup() {

    if (this.actionType === PopupAction.Delete) {
      this.configureDeletePopup();

    } else if (this.actionType === PopupAction.Cancel) {
      this.configureCancelPopup();

    } else if (this.actionType === PopupAction.CreatePeering) {
      this.configureCreatePeeringPopup();
    }

  }

  configureDeletePopup() {
    this.popupMessage = "Are you sure you want to delete the environment?";
    this.popupTitle = "Delete Environment Confirmation";
    this.showRadioButton = true;
  }

  configureCancelPopup() {
    this.popupMessage = "You will lose the peered network environments created so far. Are you sure you want to continue?";
    this.popupTitle = "Cancel Confirmation";
    this.showRadioButton = true;
  }

  configureCreatePeeringPopup() {
    this.popupMessage = "Do you really want to create the peering?";
    this.popupTitle = "Create Peering Confirmation";
    this.showRadioButton = true;
  }

  confirm() {

    if (this.actionType === PopupAction.Delete) {
      this.confirmDeletion.emit(true);
    }

    if (this.actionType === PopupAction.Cancel) {
      this.confirmCancellation.emit(true);
    }

    if (this.actionType === PopupAction.CreatePeering) {
      this.confirmPeeringCreation.emit(true);
    }

  }

}
